// Import all images
// import andros from "../assets/bahams-island/andros.jpg";
// import bimini from "../assets/bahams-island/bimini.jpg";
// import exuma from "../assets/bahams-island/exuma.jpg";
// import northEleuthera from "../assets/bahams-island/northEleuthera.jpg";
// import freePort from "../assets/bahams-island/freePort.jpg";
// import longIsland from "../assets/bahams-island/longIsland.jpg";

const abaco = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109651/abaco_i0g0br.jpg";
const andros = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109505/andros_xmzphj.png";
const bimini = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109505/bimini_ht1yu2.png";
const exuma = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109506/exuma_ql7urp.png";
const freePort = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109505/freeport_kyfpez.png";
const longIsland = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109506/long-island_ocggso.png";
const northEleuthera = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109505/eluthera_beo5q0.png";


const catIsland = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109655/catIsland_rndjfw.jpg";

const raggedIsland = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109621/raggedIsland_pvmudx.jpg";
const sanSalvador = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109626/sanSalvador_ahltkt.jpg";
const blackPoint = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109654/blackPoint_tq36n1.jpg";
const berryIsland = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109654/berryIsland_dg0u4d.jpg";
const acklins = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109651/acklins_nmp05y.jpg";
const harbourIsland = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109666/harbourIsland_fncwkr.jpg";
const highRock = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109667/highRock_gjuaiv.jpg";
const westGrandBahamas = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109667/highRock_gjuaiv.jpg";
const crookedIslandAndLongCay = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109657/crookedIslandAndLongCay_u6lmjg.jpg";
const greenTurtleCay = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109666/greenTurtleCay_kr3cvb.jpg";
const eastGrandBahamas = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109659/eastGrandBahamas_s4myni.jpg";
const governorsHarbour = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109667/governorsHarbour_ror4f9.jpg";
const kempsBay = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109668/kempsBay_sqasno.jpg";
const inaguaIslands = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109667/inaguaIslands_jv1fuo.jpg";
const marshHarbour = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109673/marshHarbour_b5z86l.jpg";
const freshCreek = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109663/freshCreek_y4mefk.jpg";
const mayaguana = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109673/mayaguana_q2kp5f.jpg";
const mooreIsland = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109675/mooreIsland_clr2ei.jpg";
const newProvidemce = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109619/newProvidemce_soqekf.jpg";
const northAbaco = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109619/northAbaco_mqlmb2.jpg";
const northAndros = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109620/northAndros_n2pa8u.jpg";


const rockSound = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109622/rockSound_n8geif.jpg";
const sandyPoint = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109624/sandyPoint_ttdlcx.jpg";
const southAbaco = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109631/southAbaco_mvfvlo.jpg";
const southAndros = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109627/southAndros_vxgkua.jpg";
const southEleuthera = "https://res.cloudinary.com/dvkl41t5v/image/upload/v1755109625/southEleuthera_dydemk.jpg";

// Create and export the islandImages object
export const islandImages = {
    "Acklins Island": acklins,
    "Andros": andros,

    "Bimimi": bimini,
    "Berry Island": andros,
    "Black Point": blackPoint,

    "Central Abaco": abaco,
    "Cat Island": catIsland,
    "Crooked Island And Long Cay": crookedIslandAndLongCay,

    // "ELEUTHERA": eleuthera,
    "Eest Grand Bahamas": eastGrandBahamas,
    "Exuma": exuma,

    "Free Port": freePort,
    "Fresh Creek": freshCreek,

    "Governor's Harbour": governorsHarbour,
    "Green Turtlecay": greenTurtleCay,

    "High Rock": highRock,
    "Harbour Island": harbourIsland,

    "Inagua": inaguaIslands,

    "Kemps Bay": kempsBay,

    "Long Island": longIsland,

    "March Harbour": marshHarbour,
    "Mayaguana": mayaguana,
    "Moore's Island": mooreIsland,

    "New Providence": newProvidemce,
    "Nichollstown and Berry Island": berryIsland,
    "North Abaco": northAbaco,
    "North Andros": northAndros,
    "North Eleuthera": northEleuthera,

    "Rock Sound": rockSound,
    "Ragged Island": raggedIsland,

    "San Salvador and Rum Cay": sanSalvador,
    "Sandy Point": sandyPoint,
    "South Abaco": southAbaco,
    "South Andros": southAndros,
    "South Eleuthera": southEleuthera,

    "West Grand Bahamas": westGrandBahamas,
};
